import { registerGroup, registerRichtext, registerText } from '@visactor/vrender-kits';

export function loadIndicatorComponent() {
  registerGroup();
  registerText();
  registerRichtext();
}
